import { render, staticRenderFns } from "./ShippingMethodTransportationForm.vue?vue&type=template&id=a7ab8c16"
import script from "./ShippingMethodTransportationForm.vue?vue&type=script&lang=js"
export * from "./ShippingMethodTransportationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports